<template>
  <div>
  </div>
</template>
<script>
export default {
  name: 'modal-idle',
};
</script>



// WEBPACK FOOTER //
// src/ModalIdle.vue